import { render } from "./CreateDisagreement.vue?vue&type=template&id=4c76c5de"
import script from "./CreateDisagreement.vue?vue&type=script&lang=js"
export * from "./CreateDisagreement.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__